<template>
	<div class="p-d-flex p-jc-center">	
		<div class="p-col-12">
		<div class="card card-w-title" style="height: 80px; background-color: #0c376c;">				
				<Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" style="background-color: #c8e1ff; border: 1px solid #e1e4e8;" />
		</div>
		<br><br><br><br>
		<div class="card" style="height: 390px; width:70%;margin: auto;">

			<Splitter style="height: 360px; width:100%">
				<SplitterPanel class="p-d-flex p-ai-center p-jc-center" style="background-color: #8dcdff;"> 
						<img alt="logo" src="assets/layout/images/logo_WebApp.png" aria-haspopup="true">
				</SplitterPanel>
				<SplitterPanel class="p-d-flex p-ai-center p-jc-center" style="background-color: #0c376c; border: 1px solid #e1e4e8;">						
				<Panel header="Ingreso al SIACV v1.0" style="width: 95%;">		
					<br>		                    
                        <div class="p-field">
                            <div class="p-float-label p-input-icon-right">
								<i class="pi pi-user" />
                                <InputText id="name" autofocus v-model="userItem.nomusuario" :class="{'p-invalid':validarErrores.nomusuario && submitted}" style="width: 300px;"/>
                                <label for="name" :class="{'p-error':validarErrores.nomusuario && submitted}">Nombre de usuario</label>
                            </div>                            
                        </div>
						
						<div class="p-field" >
                            <div class="p-float-label" style="width: 300px;">								
                                <Password id="name" v-model="userItem.passuser" :class="{'p-invalid':validarErrores.passuser && submitted}" toggleMask>
								<template #header>
                                        <h6>Ingresa la contraseña</h6>
                                    </template>
                                    <template #footer="sp">
                                        {{sp.level}}
                                        <Divider />
                                        <p class="p-mt-2">Sugerencias:</p>
                                        <ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
                                            <li>Al menos una letra minuscula</li>
                                            <li>Al menos una letra mayuscula</li>
                                            <li>Al menos un número</li>
                                            <li>Minimo 8 caracteres</li>
                                        </ul>
                                    </template>
                                </Password>
                                <label for="password">Contraseña*</label>                                
                            </div>                            
                        </div>
						<div class="p-field-checkbox">							
                            <Checkbox id="accept" name="accept" value="Accept" v-model="userItem.aceptar" :class="{'p-invalid':validarErrores.aceptar && submitted}" />
                            <label for="accept" :class="{'p-error': validarErrores.aceptar && submitted}">Estoy de acuerdo con los términos y condiciones*&nbsp; &nbsp;&nbsp; &nbsp;</label>
							<Button label="" icon="pi pi-external-link" @click="openBasicTerm" />
                        </div><br>
                        <Button label="Ingresar al Sistema" class="p-mt-2" @click="validarAuthUser"/>                   
				</Panel>
				</SplitterPanel>				
				</Splitter>

				<Dialog header="Términos y condiciones" v-model:visible="displayBasicTerm" :style="{width: '50vw'}">
					<b>1. Condiciones básicas.</b><br><br>
                    <p align="justify">El usuario es responsable del uso que haga y del contenido que registre dentro de la aplicación web. Proporcione sólo contenido solicitado de acuerdo al formato de Curriculum Vitae establecido por la Dirección y Secretaría Académica de la Facultad de Negocios CIV de la UNACH, con base a los formatos oficiales que establecen los organismos acreditadores.<br><br>
La información proporcionada es confidencial y será utilizada exclusivamente para efectos de los procesos de acreditación. Es importante proporcionar datos verídicos de acuerdo a la productividad académica del docente, mismos que permitirán la generación del documento CVU del docente. No es necesario incluir anexos ni comprobantes originales.<br><br>
El usuario deberá respetar en todo momento los presentes Términos y Condiciones de Uso de la aplicación web. De forma expresa el usuario manifiesta que utilizará el software de forma diligente y asumiendo cualquier responsabilidad que pudiera derivarse del incumplimiento de las normas.</p>                    
                </Dialog>


			</div>	
		</div>
	</div>
</template>
<script>
//import apiAuthUser from '@/service/LoginUserService';

	export default {
		data() {
			return {
				userItem: {
						nomusuario: null,
						passuser: null,
						aceptar:null						
					},
					validarErrores: {},
					submitted: false,					
					displayBasicTerm: false,
					breadcrumbHome: {icon: 'pi pi-home', to: '/'},
					breadcrumbItems: [
						{label:'Facultad de Negocios CIV UNACH'},
						{label:'SIAC (Sistema Administrador de Curriculum Vitae CONAIC)'}						
					]
			}
		},
		methods: {
			openBasicTerm() {
				this.displayBasicTerm = true;				
			},
			validarAuthUser: async function() {
				//await apiAuthUser.updateMaterial(this.userItem.nomusuario, this.userItem.passuser);
				window.localStorage.setItem('tokenlogin', 'true');
				this.$router.push("/AppCentral");
			}
		}
	}
</script>
<style>
.p-menuitem-text{
	font-weight: bold;
	color:#fff;
}
</style>